import { SecurityContext } from "@angular/core";
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";

export function createAudioDurationValidator(
  sanitizer: DomSanitizer,
  duration = 60
): AsyncValidatorFn {
  return (control: AbstractControl): Promise<ValidationErrors | null> => {
    const file = control.value;
    if (!file) {
      // eslint-disable-next-line no-null/no-null
      return Promise.resolve(null);
    }
    return new Promise(resolve => {
      if (!file.size) {
        // eslint-disable-next-line no-null/no-null
        resolve(null);
        return;
      }
      const sanitizedRecordedFile = sanitizer.bypassSecurityTrustResourceUrl(
        URL.createObjectURL(file)
      );
      const audio = new Audio();
      audio.src = sanitizer.sanitize(SecurityContext.RESOURCE_URL, sanitizedRecordedFile) || "";
      let audioDuration;
      audio.addEventListener("loadedmetadata", () => {
        audioDuration = audio.duration;
        if (audioDuration > duration) {
          resolve({ tooLongDuration: true });
        } else {
          // eslint-disable-next-line no-null/no-null
          resolve(null);
        }
      });
    });
  };
}
